export const navigationData = {
  logo: "ASCENCIO",
  links: [
    { text: "Home", path: "/" },
    {
      text: "Services",
      path: "/services",
      hasDropdown: true,
      submenu: [
        {
          text: "Lead Generation",
          path: "/services#lead-generation",
          iconName: "Users",
        },
        {
          text: "Social Media & Calendar",
          path: "/services#social-media",
          iconName: "Calendar",
        },
        {
          text: "Automations",
          path: "/services#automations",
          iconName: "Workflow",
        },
        {
          text: "Website Design",
          path: "/services#website",
          iconName: "Globe",
        },
      ],
    },
    { text: "How It Works", path: "/how-it-works" },
    { text: "Contact", path: "/contact" },
  ],
  ctaButton: {
    text: "Get Started",
    path: "/contact",
  },
};
